import React, { useState, useEffect } from 'react'
import { Typography } from '@material-ui/core'
import styled from 'styled-components'
import AvTimerIcon from '@material-ui/icons/AvTimer';

const Text = styled.span`
    color: ${({ level }) => (level ? level : 'unset')};
    font-size: 16px;
    display: flex;
    margin-left: 8px
`

const QuestionDifficulty = ({ questionContent }) => {
    const [difficulty, setDifficulty] = useState()

    const setLevel = (value) => {
        let questionLevel = {}
        switch (value) {
            case 'Fácil':
                questionLevel = '#429447'
                break;
            case 'Médio': 
                questionLevel = '#ff9e19'
                break;
            case 'Difícil':
                questionLevel = '#fd1e23'
                break;
            default:
        }
        setDifficulty(questionLevel)
    }

    useEffect(() => {
        questionContent && setLevel((questionContent || {}).label)
    }, [questionContent])

    return (
        (questionContent || {}).label ? <Typography gutterBottom variant="body1" component="span" style={{ display: 'flex' }}>
            Dificuldade:<Text level={difficulty || {}}>{(questionContent || {}).label}<AvTimerIcon /></Text>
        </Typography> : ''
    )
}

export default QuestionDifficulty